import template from './createContractModal.html';
import controller from './createContractModal.controller';

let CreateContractModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

export default CreateContractModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/createContractModal/createContractModal.component.js